// =============================================================================
// VandieZ admin-web -- shadcn-style Skeleton placeholder
// =============================================================================
// A minimal animate-pulse div used as a content placeholder while data is
// loading on its initial fetch. Pages keep stale data visible on refresh,
// so the skeleton path only fires when `loading && items.length === 0`
// (or the detail equivalent: `loading && detail === null`).
// =============================================================================

import type React from "react";

import { cn } from "@/lib/utils";

export function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): React.JSX.Element {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  );
}

// -----------------------------------------------------------------------------
// TableSkeleton -- N rows of M column-shaped bars, matched to the list page
// table headers above. `columns` is the number of <td> placeholders to
// render per row.
// -----------------------------------------------------------------------------
export function TableSkeleton({
  rows = 5,
  columns,
}: {
  rows?: number;
  columns: number;
}): React.JSX.Element {
  return (
    <div className="space-y-2 py-2" data-testid="table-skeleton">
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <div
          key={rowIdx}
          className="flex items-center gap-3 border-b py-3 last:border-b-0"
        >
          {Array.from({ length: columns }).map((_, colIdx) => (
            <Skeleton
              key={colIdx}
              className={cn(
                "h-4 flex-1",
                // Vary widths slightly so the skeleton doesn't look like
                // a grid of identical bars.
                colIdx === 0 && "max-w-[28%]",
                colIdx === columns - 1 && "max-w-[14%]",
              )}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
